import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";

export class supplyAccountSelectCtrl implements IController {

  selectedId: any;
  ngPlaceholder: any;
  isBusiness?: boolean;
  isExternal?: boolean;
  branchIds?: string[];
  type: any;
  isDisabled: boolean;
  isRequired: boolean;
  onChange: Function;

  private accountsRef: any;
  public selectedAccount: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $accounts: $accountsFactory, private $element) {
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this._setSelectedAccount();
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()){
      this._setSelectedAccount();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const ngPlaceholderRef = this.ngPlaceholder;
    const queryMapRef = {
      isBusiness: this.isBusiness,
      isExternal: this.isExternal,
      type: this.type
    };
    const branchIdsRef = this.branchIds;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'query-map="ctrl.queryMap" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'carrier';
        this.selectedIdRef = selectedIdRef;
        this.branchIdsRef = branchIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMap = queryMapRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!!selectedId) {
          this.accountsRef.$asyncValues([selectedId])
            .then((accounts) => {
              this.onChange({account: accounts[0], id: selectedId});
              panel.destroy();
            });
        } else {
          this.onChange({account: undefined});
          panel.destroy();
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({account: undefined});
  }

  private _setSelectedAccount() {
    if (!!this.selectedId) {
      this.accountsRef.$asyncValues([this.selectedId])
        .then((accounts) => {
          this.selectedAccount = _.orderBy(accounts, ['name'], ['asc'])[0];
          this._setSelectedText()
        });
    } else {
      this.selectedAccount = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedAccount, 'name', '');
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      isBusiness: '<?',
      isExternal: '<?',
      branchIds: '<?',
      type: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./supply-account-select.html').default,
    controller: supplyAccountSelectCtrl
  });
